import { useEffect, useRef, useState } from "react";

export const useDropdownLogicWithClickingOutside = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState<boolean>(false)
  const [activeDropdown, setActiveDropdown] = useState<string | null>(null)
  const dropdownRef = useRef<HTMLDivElement | null>(null)
  
  const toggleDropdown = (dropdownId: string) => {
    setActiveDropdown((prev) => prev === dropdownId ? "" : dropdownId)
    setIsDropdownOpen((prev) => prev === isDropdownOpen ? true : false)
  }
  
  const handleClickOutside = (event: MouseEvent) => {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target as Node)
    ) {
      setActiveDropdown("");
      setIsDropdownOpen(false)
    }
  };
  
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);  

  return {
    toggleDropdown,
    activeDropdown,
    dropdownRef,
    isDropdownOpen
  }
}